/**
 * Frontend JavaScript for WCP Reviews Slider Block
 * Loads Splide from CDN and initializes the slider
 */

// Namespace to avoid conflicts
window.Strength9ReviewsSlider = {
    splideLoaded: false,
    
    // Load Splide CSS and JS from CDN
    loadSplide: function() {
        return new Promise((resolve, reject) => {
            // Check if Splide is already loaded
            if (window.Splide || this.splideLoaded) {
                resolve();
                return;
            }
            
            // Load CSS first
            const cssLink = document.createElement('link');
            cssLink.rel = 'stylesheet';
            cssLink.href = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css';
            cssLink.id = 'strength9-splide-css';
            
            // Load JS
            const jsScript = document.createElement('script');
            jsScript.src = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
            jsScript.id = 'strength9-splide-js';
            
            // Handle script load
            jsScript.onload = () => {
                this.splideLoaded = true;
                resolve();
            };
            
            jsScript.onerror = () => {
                console.error('Failed to load Splide.js');
                reject(new Error('Failed to load Splide.js'));
            };
            
            // Add to document
            document.head.appendChild(cssLink);
            document.head.appendChild(jsScript);
        });
    },
    
    // Initialize all sliders on the page
    initSliders: function() {
        const sliders = document.querySelectorAll('.strength9-reviews-slider');
        
        if (sliders.length === 0) {
            return;
        }
        
        this.loadSplide().then(() => {
            sliders.forEach(slider => {
                // Get configuration from data attribute
                const config = slider.getAttribute('data-splide');
                let options = {};
                
                try {
                    options = config ? JSON.parse(config) : {};
                } catch (e) {
                    console.warn('Invalid Splide configuration:', e);
                }
                
                // Default configuration with 20-second intervals
                const defaultOptions = {
                    type: 'loop',
                    autoplay: true,
                    interval: 20000, // 20 seconds
                    perPage: 3,
                    perMove: 3,
                    gap: '2rem',
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    resetProgress: false,
                    arrows: true, // Hide navigation arrows for cleaner look
                    pagination: false,
                    breakpoints: {
                        768: {
                            perPage: 1,
                            perMove: 1,
                            gap: '1rem'
                        },
                        1024: {
                            perPage: 2,
                            perMove: 2,
                            gap: '1.5rem'
                        }
                    }
                };
                
                // Merge options
                const finalOptions = { ...defaultOptions, ...options };
                
                // Initialize Splide
                try {
                    const splide = new Splide(slider, finalOptions);
                    splide.mount();
                    
                    // Add custom event listeners if needed
                    splide.on('autoplay:playing', () => {
                        // Optional: Add any custom logic when autoplay starts
                    });
                    
                    splide.on('autoplay:pause', () => {
                        // Optional: Add any custom logic when autoplay pauses
                    });
                    
                } catch (error) {
                    console.error('Failed to initialize Splide slider:', error);
                }
            });
        }).catch(error => {
            console.error('Failed to load Splide library:', error);
        });
    },
    
    // Initialize when DOM is ready
    init: function() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.initSliders();
            });
        } else {
            this.initSliders();
        }
    }
};

// Auto-initialize when script loads
Strength9ReviewsSlider.init();

// Also initialize on window load as fallback
window.addEventListener('load', () => {
    Strength9ReviewsSlider.initSliders();
});

// Re-initialize if new blocks are added dynamically (for block editor)
if (window.wp && window.wp.domReady) {
    wp.domReady(() => {
        Strength9ReviewsSlider.initSliders();
    });
}
